import { render } from "./NoticeModal.vue?vue&type=template&id=4337b140&scoped=true"
import script from "./NoticeModal.vue?vue&type=script&lang=js"
export * from "./NoticeModal.vue?vue&type=script&lang=js"

import "./NoticeModal.vue?vue&type=style&index=0&id=4337b140&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\user\\Documents\\sparta-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4337b140"]])

export default __exports__